"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));
var _checkCategoryIdByPath = _interopRequireDefault(require("./checkCategoryIdByPath"));
var getMainCategoryId = function getMainCategoryId(_ref) {
  var idList = _ref.idList,
    paths = _ref.paths;
  var mainCategory = 2;
  if (idList.length > 0) {
    var ids = (0, _toConsumableArray2["default"])(new Set(idList));
    mainCategory = ids.find(function (category) {
      return (0, _checkCategoryIdByPath["default"])({
        paths: paths,
        id: category
      }) === category;
    });
  }
  return mainCategory;
};
var _default = getMainCategoryId;
exports["default"] = _default;